import {
  termsOfUse,
  privacyPolicy,
  refundPolicy,
  contactDetails,
} from './legalContent';

export const LEGAL_PAGES = {
  'terms-of-use': {
    slug: 'terms-of-use',
    title: 'Terms of Use',
    description:
      'Terms and conditions governing your access to and use of Cognidoor products, services, and website.',
    markdown: termsOfUse,
    expectedHeading: '# Terms of Use',
  },
  'privacy-policy': {
    slug: 'privacy-policy',
    title: 'Privacy Policy',
    description:
      'How Cognidoor collects, uses, stores, and protects your personal information.',
    markdown: privacyPolicy,
    expectedHeading: '# Privacy Policy',
  },
  'refund-policy': {
    slug: 'refund-policy',
    title: 'Refund Policy',
    description:
      'Cognidoor refund eligibility, request process, and payment-provider handling.',
    markdown: refundPolicy,
    expectedHeading: '# Refund Policy',
  },
  contact: {
    slug: 'contact',
    title: 'Contact',
    description:
      'Contact Cognidoor for support, account access, payments, refunds, and privacy requests.',
    markdown: contactDetails,
    expectedHeading: '# Contact Details',
  },
};

export const LEGAL_PAGE_SLUGS = Object.keys(LEGAL_PAGES);

export function getLegalPage(slug) {
  return LEGAL_PAGES[slug] || null;
}

export const OTHER_LEGAL_LINKS = LEGAL_PAGE_SLUGS.map((slug) => ({
  slug,
  title: LEGAL_PAGES[slug].title,
  path: slug === 'contact' ? '/contact' : `/${slug}`,
}));
